import { chainListStore } from '../../store/chainList';
import { debugLog, getRpcUrl } from '../../utils/common';
import { walletIdMap } from '../../utils/constants';
import { WalletConnectConnector } from '../connectors/evm/WalletConnectConnector';
import { WalletHub } from '../core/WalletHub';
import { isBrowser, onlyRunOnce } from '../misc';

const wallectIcon =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iOCIgZmlsbD0idXJsKCNwcmVmaXhfX3BhaW50MF9yYWRpYWxfMTMxNV8yMzQ3MTYpIi8+PHBhdGggZD0iTTEwLjA0NyAxMi4zNThjMy4yMTktMy4xNDQgOC40NDQtMy4xNDQgMTEuNjYyIDBsLjM4OC4zODFhLjM5My4zOTMgMCAwMTAgLjU2OWwtMS4zMjUgMS4yOTRhLjIwOC4yMDggMCAwMS0uMjk0IDBsLS41MzEtLjUyYy0yLjI1LTIuMTkzLTUuODg4LTIuMTkzLTguMTM4IDBsLS41NjguNTU3YS4yMDguMjA4IDAgMDEtLjI5NCAwbC0xLjMyNS0xLjI5NGEuMzkzLjM5MyAwIDAxMC0uNTY4bC40MjUtLjQyem0xNC40MDYgMi42NzVsMS4xODEgMS4xNWEuMzkzLjM5MyAwIDAxMCAuNTY5bC01LjMxOCA1LjE5M2EuNDE5LjQxOSAwIDAxLS41ODIgMGwtMy43NzUtMy42ODdhLjEwNi4xMDYgMCAwMC0uMTQzIDBsLTMuNzc1IDMuNjg3YS40MTkuNDE5IDAgMDEtLjU4MiAwbC01LjMzNy01LjE5M2EuMzkzLjM5MyAwIDAxMC0uNTdsMS4xODEtMS4xNWEuNDIuNDIgMCAwMS41ODEgMGwzLjc3NSAzLjY4OGEuMTA2LjEwNiAwIDAwLjE0NCAwbDMuNzc1LTMuNjg3YS40Mi40MiAwIDAxLjU4MSAwbDMuNzc1IDMuNjg3YS4xMDYuMTA2IDAgMDAuMTQ0IDBsMy43NzUtMy42ODdhLjQ0My40NDMgMCAwMS42IDB6IiBmaWxsPSIjZmZmIi8+PGRlZnM+PHJhZGlhbEdyYWRpZW50IGlkPSJwcmVmaXhfX3BhaW50MF9yYWRpYWxfMTMxNV8yMzQ3MTYiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMzIgMCAwIDMyIDAgMTYpIj48c3RvcCBzdG9wLWNvbG9yPSIjNUQ5REY2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDA2RkZGIi8+PC9yYWRpYWxHcmFkaWVudD48L2RlZnM+PC9zdmc+';

const getWcConfig = async () => {
  await chainListStore.getChainList();
  const chains = chainListStore.state.evmChains;
  const wcConfig = {
    projectId: '5bb28bbdbc33de82c2d5ffb86fc402c0',
    chains: [1],
    optionalChains: chains.map((c) => c.chainId),
    rpcMap: chains.reduce(
      (acc, chain) => {
        acc[chain.chainId] = getRpcUrl(chain.chainCode);
        return acc;
      },
      {} as Record<string, string>,
    ),
    metadata: {
      name: 'Bybit Web3',
      description:
        'Your gateway to Web3. Earn airdrops, explore DeFi offerings, browse NFT & BTC marketplaces, and trade thousands of tokens across various networks.',
      url: `${isBrowser ? window.location.origin : ''}/web3`,
      icons: ['https://www.bybit.com/common-static/fhs/bybit-home-new/favicon.ico'],
    },
  };
  return wcConfig;
};

export const evmWalletConnectHub = new WalletHub({
  name: 'Wallet Connect',
  id: walletIdMap.walletConnect,
  icon: wallectIcon,
  connectors: [
    async () => {
      const config = await getWcConfig();
      // @ts-ignore
      return new WalletConnectConnector(walletIdMap.walletConnect, { ...config, showQrModal: true });
    },
  ],
});

export const bybitWcConnectHub = new WalletHub({
  name: 'Bybit Wallet App',
  id: walletIdMap.bybitWalletConnect,
  icon: '',
  connectors: [
    async () => {
      const config = await getWcConfig();
      // @ts-ignore
      return new WalletConnectConnector(walletIdMap.bybitWalletConnect, {
        ...config,
        qrModalOptions: {
          enableExplorer: false,
        },
        showQrModal: true,
      });
    },
  ],
});

export const preloadWcConnectProvider = onlyRunOnce(async () => {
  await bybitWcConnectHub.initConnectors();
  await evmWalletConnectHub.initConnectors();
  bybitWcConnectHub.EVM?.getProvider()?.catch(debugLog.bind(null, 'Load bybit wc error'));
  evmWalletConnectHub.EVM?.getProvider()?.catch(debugLog.bind(null, 'Load wc error'));
});
